import { render } from "./TeamSprintSummaryCard.vue?vue&type=template&id=2018b720&scoped=true"
import script from "./TeamSprintSummaryCard.vue?vue&type=script&lang=js"
export * from "./TeamSprintSummaryCard.vue?vue&type=script&lang=js"

import "./TeamSprintSummaryCard.vue?vue&type=style&index=0&id=2018b720&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2018b720"]])

export default __exports__